// src/components/Cart.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import EmptyState from './EmptyState'; 

const Cart = () => {
  const { items, removeFromCart, updateQuantity, totalPrice } = useCart();
  const shipping = 25;
  const total = totalPrice + shipping;

  return (
    <div className="container mx-auto p-8 md:p-16" dir="rtl">
      {/* زر العودة إلى الرئيسية */}
      <div className="absolute top-2 left-2">
        <Link to="/" className="inline-flex items-center px-2 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-yellow-500 hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-400 transition-colors duration-200">
          العودة إلى الرئيسية
          <svg className="h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </Link>
      </div>

      {/* قسم العنوان والمقدمة */}
      <div className="text-center mb-16">
        <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-4 animate-fade-in-down">
          عربة التسوق
        </h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto animate-fade-in-up">
          المنتجات المضافة حديثًا إلى سلتك.
        </p>
      </div>

      <div className="grid lg:grid-cols-3 gap-12">
        {/* عمود المنتجات */}
        <div className="lg:col-span-2">
          {items.length > 0 ? (
            items.map((item) => (
              <div key={item.id} className="flex flex-col sm:flex-row items-center justify-between bg-white p-6 rounded-lg shadow-md mb-6 animate-slide-up-item group transition-shadow duration-300 hover:shadow-xl">
                <div className="flex items-center w-full sm:w-auto">
                  <img src={item.image} alt={item.name} className="h-24 w-24 object-cover rounded-md ml-4 transition-transform duration-300 group-hover:scale-105" />
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-gray-900">{item.name}</h3>
                    <p className="text-lg font-semibold text-blue-600 mt-2">{item.price} ر.س</p>
                  </div>
                </div>
                <div className="flex items-center mt-4 sm:mt-0">
                  <div className="flex items-center border border-gray-300 rounded-md">
                    <button
                      onClick={() => updateQuantity(item.id, item.quantity - 1)}
                      className="p-2 text-gray-600 hover:bg-gray-100 transition-colors duration-200"
                    >
                      -
                    </button>
                    <span className="p-2 text-gray-800">{item.quantity}</span>
                    <button
                      onClick={() => updateQuantity(item.id, item.quantity + 1)}
                      className="p-2 text-gray-600 hover:bg-gray-100 transition-colors duration-200"
                    >
                      +
                    </button>
                  </div>
                  <button
                    onClick={() => removeFromCart(item.id)}
                    className="mr-4 text-gray-500 hover:text-red-500 transition-colors duration-200"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>
              </div>
            ))
          ) : (
            <EmptyState
              message="عربة التسوق فارغة حاليًا."
              linkText="اذهب للتسوق"
              linkTo="/"
              icon={<svg xmlns="http://www.w3.org/2000/svg" className="h-20 w-20" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" /></svg>}
            />
          )}
        </div>

        {/* عمود ملخص الطلب */}
        <div className="bg-white p-8 rounded-lg shadow-xl animate-slide-left h-fit">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">ملخص الطلب</h2>
          <div className="space-y-4">
            <div className="flex justify-between items-center text-gray-600">
              <span>المجموع الفرعي:</span>
              <span className="font-semibold text-gray-800">{totalPrice.toFixed(2)} ر.س</span>
            </div>
            <div className="flex justify-between items-center text-gray-600">
              <span>رسوم الشحن:</span>
              <span className="font-semibold text-gray-800">{shipping.toFixed(2)} ر.س</span>
            </div>
            <div className="border-t border-gray-200 pt-4 flex justify-between items-center text-xl font-bold text-gray-900">
              <span>المجموع الكلي:</span>
              <span>{total.toFixed(2)} ر.س</span>
            </div>
          </div>
          <button className="mt-8 w-full bg-yellow-500 text-white font-bold py-3 px-6 rounded-md hover:bg-yellow-600 transition-colors duration-200">
            متابعة الدفع
          </button>
        </div>
      </div>
      
    </div>
  );
};

export default Cart;
